import { render } from "./AuthorizationHeader.vue?vue&type=template&id=46dfb0e2&scoped=true"
import script from "./AuthorizationHeader.vue?vue&type=script&lang=js"
export * from "./AuthorizationHeader.vue?vue&type=script&lang=js"

import "./AuthorizationHeader.vue?vue&type=style&index=0&id=46dfb0e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46dfb0e2"]])

export default __exports__